import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../../../services/apiService';

/**
 * Wraps protected routes. Redirects to /login when there is no access token
 * in sessionStorage.
 */
const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    if (!authService.isAuthenticated()) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;